(() => {
  const items = document.querySelectorAll('.nova-reveal');
  if (!items.length || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  items.forEach((item) => observer.observe(item));
})();

/* NOVAWEAR 0.5.9.2 — progressive homepage link upgrades only.
   This runs after the server-rendered homepage is complete and never touches
   Shopify routing, section schemas or the Theme Editor fallback. */
(() => {
  const isHomepage = document.body.classList.contains('nova-home-root');
  if (!isHomepage) return;
  const localeRoot = (window.NewEden?.routes?.root_url || '').replace(/\/$/, '');
  const localizedPath = (path) => `${localeRoot}${path}`;

  const isGenericCollectionLink = (anchor) => {
    if (!anchor) return false;
    const href = anchor.getAttribute('href') || '';
    return href === '/collections/all' || href === localizedPath('/collections/all') || href.endsWith('/collections/all');
  };

  const heroButton = document.querySelector('.nova-reference-hero .hero__buttons a:first-child');
  if (isGenericCollectionLink(heroButton)) {
    heroButton.setAttribute('href', localizedPath('/collections/bestseller'));
    heroButton.dataset.novaLinkUpgrade = 'bestseller';
  }

  document.querySelectorAll('.image-card-carousel--shop-looks .image-card-carousel__link').forEach((cardLink) => {
    if (!isGenericCollectionLink(cardLink)) return;

    const title = cardLink.querySelector('.image-card-carousel__title')?.textContent?.trim();
    if (!title) return;

    const searchTerm = title.replace(/\s+(LOOK|SET)$/i, '').replace(/^ALL\s+/i, '').trim();
    if (!searchTerm) return;

    cardLink.setAttribute('href', `${localizedPath('/search')}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(searchTerm)}`);
    cardLink.dataset.novaLinkUpgrade = 'look-search';
  });
})();
